const plugins: Record<string, any> = {};
export default plugins;